import React, { Component } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Body from '../Body/Body';
import './Home.css';

class Home extends Component {
  render() {
    return (
      <div className="home-page">
        <Header />
        <main id="main-content">
          <Body />
        </main>
        <Footer />
      </div>
    );
  }
}

export default Home;
